import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ExperienceSection from '../components/ExperienceSection';
import ProductRangeSection from '../components/ProductRangeSection';
import WhyChooseSection from '../components/WhyChooseSection';
import IndustriesSection from '../components/IndustriesSection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <ExperienceSection />
      <ProductRangeSection />
      <WhyChooseSection />
      <IndustriesSection />
    </div>
  );
};

export default Home;